// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Mz-z","tooltipWrapper":"Nz-z","icon":"Oz-z","tooltip":"Pz-z","content":"Qz-z"};